import React from 'react';
import {
  DataSection,
  SectionHeading,
  DataFeatures,
  DataFeature,
  DataNumber,
} from './Data.styles';
const Data = () => {
  return (
    <DataSection>
      <SectionHeading>
        <p className="eyebrowHeader">More Than a Saved PDF</p>

        <h2>Find the Information Inside Your Forms</h2>

        <p>
          Digital forms are most useful when the information inside them can
          actually be found again. Completed submissions can be reviewed and
          filtered so your team can work with the data collected through your
          forms.
        </p>
      </SectionHeading>

      <DataFeatures>
        <DataFeature>
          <DataNumber>01</DataNumber>

          <div>
            <h3>View Completed Forms</h3>
            <p>
              Access submitted forms without digging through filing cabinets or
              scattered paper copies.
            </p>
          </div>
        </DataFeature>

        <DataFeature>
          <DataNumber>02</DataNumber>

          <div>
            <h3>Filter Records</h3>
            <p>
              Narrow down completed forms using the information available in
              your records.
            </p>
          </div>
        </DataFeature>

        <DataFeature>
          <DataNumber>03</DataNumber>

          <div>
            <h3>Query Form Data</h3>
            <p>
              Search across collected information to find the records that
              matter to your team.
            </p>
          </div>
        </DataFeature>
      </DataFeatures>
    </DataSection>
  );
};

export default Data;
